import React from "react"
import { navigate } from "gatsby"
import * as lang from "../../../languages"
import { connect } from "react-redux"
import { CHANGE_LOCALE } from "../../state/constants"
import "./index.scss"

export const Locale = connect(state => state.app.selectedLocale)(({ id, pageContext, pathContext, location, ...props }) => {
  // console.log(pageContext);
  // console.log(pathContext);
  // console.log(location);
  // console.log(props);

  const locales = lang.languages

  const onChangeLocale = (e) => {
    if (e.target.value === "de-ch") {
      if (typeof window !== "undefined") {
        window.open(
          'https://heidi-chocolate.ch/',
          '_blank'
        );
      }
      return
    }

    // console.log(e.target.value)
    if (e.target.value === pathContext.lang) {
      return
    }

    props.dispatch({
      type: CHANGE_LOCALE,
      locale: lang.languages.find(l => l.locale === e.target.value)
    })

    if (e.target.value === lang.defaultLang) {
      navigate(location.pathname.replace(`/${pathContext.lang}`, ""))
    } else {
      if (pathContext.lang === lang.defaultLang) {
        navigate(`/${e.target.value}${location.pathname}`)
      } else {
        navigate(location.pathname.replace(`/${pathContext.lang}`, `/${e.target.value}`))
      }
    }
  }

  const getDefaultLang = () => {
    return (pageContext && pageContext.lang) || locales.find(l => l.locale === lang.defaultLang)
  }
  return (
    <>
      <select className="app-locale-selector" onChange={onChangeLocale} defaultValue={getDefaultLang()}>
        {locales.map(country => <option key={country.locale} value={country.locale}>{country.label}</option>)}
      </select>
      {/*<img src={ArrowDown} alt=""/>*/}
    </>
  )
})
